import {
  Box, Card, CircularProgress, Typography,
} from '@mui/material';
import { useAppSelector } from '../../../app/hooks';
import { ReactComponent as Book } from '../../../assets/svg/thatBook/bookIconNoColor.svg';

const CardTotalBooks = () => {
  const { generalStatistics, loadingGeneralStatistic } = useAppSelector(( state ) => state.dashboard );
  const { books } = generalStatistics;
  return (
    <Card sx={{ backgroundColor: '#29314F', color: 'white', height: '100%' }}>
      <Box p={2} display="flex" justifyContent="space-between" alignItems="center">
        <Box minHeight={60}>
          <Typography variant="h6">
            {loadingGeneralStatistic ? <CircularProgress size={24} color="inherit" /> : (
              <>
                {books.created}
              </>
            )}
          </Typography>
          <Typography variant="subtitle1">Libros</Typography>
        </Box>
        <Book width={50} height={50} fill="white" />
      </Box>
    </Card>
  );
};

export default CardTotalBooks;
